export default {
  'ADMIN_USER' (state) {
    return state.admin_user
  },
  'ADMIN_USERS' (state) {
    return state.admin_users
  }
}
